import { InjectionToken } from '@angular/core';

export const APP_USES_LOGIN = new InjectionToken<boolean>(
  'Use this token to set or get whether or not the app uses login.'
);
